// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup {
  margin-top: 6rem;
}

.signup-box {
  width: 18rem;
}

.icon-signup {
  height: 3rem;
  width: 3rem;
}

.btn-signup {
  width: 14.4rem;
}

.helper-lg {
  margin-top: 1.5rem;
  font-size: 1rem;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/ResetPassword/ResetPassword.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AACJ","sourcesContent":[".signup {\n    margin-top: 6rem;\n}\n\n.signup-box {\n    width: 18rem;\n}\n\n.icon-signup {\n    height: 3rem;\n    width: 3rem;\n}\n\n.btn-signup {\n    width: 14.4rem;\n}\n\n.helper-lg{\n    margin-top: 1.5rem;\n    font-size: 1rem;\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
